/**
 * ANIMATE モジュール
 * - .js-animate 要素：画面内に入ったらクラス "is-shown" を付与
 * - .js-circle 要素：スクロールに応じてスケーリング変化
 */
export const ANIMATE = {
  init() {
    this.setupIntersectionAnimations()
    this.setupScrollCircleAnimation()
  },

  /**
   * .js-animate 要素に IntersectionObserver を適用して表示アニメーションを付与
   */
  setupIntersectionAnimations() {
    const targets = document.querySelectorAll('.js-animate')
    if (!targets.length) return

    const rootMargin = window.innerWidth > 768 ? '0px 0px -20% 0px' : '0px 0px -15% 0px'

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-shown')
            // 一度表示されたら監視解除したい場合はこちらを有効化
            // observer.unobserve(entry.target);
          }
        })
      },
      {
        rootMargin,
        threshold: 0,
      },
    )

    targets.forEach(target => observer.observe(target))
  },

  /**
   * .js-circle 要素に対してスクロールに応じたスケーリングアニメーションを適用
   */
  setupScrollCircleAnimation() {
    const circle = document.querySelector('.js-circle')
    if (!circle) return

    const windowHeight = window.innerHeight * 0.8

    window.addEventListener('scroll', () => {
      const rect = circle.getBoundingClientRect()
      const top = rect.top
      const scrollY = window.scrollY

      // ページトップ時にリセット
      if (scrollY === 0) {
        circle.style.transform = 'translateX(-50%) scale(1)'
        return
      }

      // 表示領域内のときにスケール処理
      if (top < windowHeight && top > 0) {
        const progress = 1 - top / windowHeight
        const scale = 1 + progress * 0.4
        circle.style.transform = `translateX(-50%) scale(${scale})`
      }
    })
  },
}
